export default class ThemeLoadingAnim extends HTMLElement {
  constructor() {
    super();
    let template = `
      <style>
        @keyframes rotate {
          100% {
            transform:rotate(360deg);
          }
        }
        :host {
          width: 100%;
          height: 100%;
          display: grid;
          pointer-events: none;
        }
        div {
          justify-self: center;
          align-self: center;
          width: 60px;
          height: 60px;
          opacity: 1;
          visibility: visible;
          transition: all 0.3s ease-out;
        }
        div[data-show="false"] {
          opacity: 0;
          visibility: hidden;
        }
        svg {
          transform-origin: center;
          animation: rotate .6s linear infinite;
        }
        @media (min-width: 720px) {
          div {
            width: 104px;
            height: 104px;
          }
        }
      </style>

      <div data-show="true">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M2,12A11.2,11.2,0,0,1,13,1.05C12.67,1,12.34,1,12,1a11,11,0,0,0,0,22c.34,0,.67,0,1-.05C6,23,2,17.74,2,12Z"/>
        </svg>
      </div>
    `;
    let doc = new DOMParser().parseFromString(template, "text/html");
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = doc.documentElement.innerHTML;
    this.div = this.shadowRoot.querySelector('div');
    this.svg = this.shadowRoot.querySelector('svg');
    this.loading = true;
  }

  static get observedAttributes() {
    return ['data-loading', 'fill'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-loading') {
      this.loading = newValue === 'true';
      this.div.dataset.show = this.loading;
    }
    if (name === 'fill') {
      this.svg.setAttribute('fill', newValue);
    }
  }
}

customElements.define('theme-loading-anim', ThemeLoadingAnim);